// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { changeEventSchedule, exportSchedule, getListSchedule, revertScheduleToJob } from './scheduleThunk';

export interface IScheduleState {
  isRefreshScheduleList: boolean;
}

export const initialState: IScheduleState = {
  isRefreshScheduleList: false,
};

const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {
    setRefreshScheduleList: (state, action) => {
      state.isRefreshScheduleList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get list schedule
    builder
      .addCase(getListSchedule.pending, (_state) => {})
      .addCase(getListSchedule.fulfilled, (_state) => {})
      .addCase(getListSchedule.rejected, (_state) => {});

    // GET: Export schedule
    builder
      .addCase(exportSchedule.pending, (_state) => {})
      .addCase(exportSchedule.fulfilled, (_state) => {})
      .addCase(exportSchedule.rejected, (_state) => {});

    // PUT: Change event schedule
    builder
      .addCase(changeEventSchedule.pending, (_state) => {})
      .addCase(changeEventSchedule.fulfilled, (_state) => {})
      .addCase(changeEventSchedule.rejected, (_state) => {});

    // POST:Revert Schedule To Job
    builder
      .addCase(revertScheduleToJob.pending, (_state) => {})
      .addCase(revertScheduleToJob.fulfilled, (_state) => {})
      .addCase(revertScheduleToJob.rejected, (_state) => {});
  },
});

// Action
export const scheduleActions = scheduleSlice.actions;

// Selectors
export const selectIsRefreshScheduleList = (state: RootState) => state.schedule.isRefreshScheduleList;

// Reducer
const scheduleReducer = scheduleSlice.reducer;
export default scheduleReducer;
